/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Match.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import InvoiceLink from './InvoiceLink/view.js'
import MainMember from './MainMember/logic.js'
import MemberCard from './MemberCard/view.js'
import PaymentStatus from './PaymentStatus/view.js'
import PlanName from './PlanName/view.js'
import React from 'react'
import Status from './Status/logic.js'
import { css } from "emotion"
MainMember.displayName = 'MainMemberLogic'
Status.displayName = 'StatusLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto"})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
justifyContent: "center",
flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
marginTop: 80})
styles.Vertical1 = css({label: 'Vertical1',
  width: 400})
styles.Vertical2 = css({label: 'Vertical2',
  justifyContent: "center",
width: 200,
height: 200})
styles.Vertical3 = css({label: 'Vertical3',
  marginTop: 50,
marginLeft: 20})

export default function Match({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Verify/Result/Match"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Match.Vertical"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="Match.Horizontal"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
 className={`views-block ${styles.Horizontal}`}
>
<div
 data-testid="Match.Vertical:1"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
 className={`views-block ${styles.Vertical1}`}
>
<MemberCard
 data-testid="Match.MemberCard"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/MemberCard`}
/>
</div>
<div
 data-testid="Match.Vertical:2"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
 className={`views-block ${styles.Vertical2}`}
>
<Status
 data-testid="Match.Status"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/Status`}
/>
<PlanName
 data-testid="Match.PlanName"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/PlanName`}
/>
<PaymentStatus
 data-testid="Match.PaymentStatus"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/PaymentStatus`}
/>
<InvoiceLink
 data-testid="Match.InvoiceLink"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/InvoiceLink`}
/>
</div>
</div>
<div
 data-testid="Match.Vertical:3"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
 className={`views-block ${styles.Vertical3}`}
>
<MainMember
 data-testid="Match.MainMember"
 data-view-path="/App/MyAccount/Content/Verify/Result/Match"
viewPath={`${viewPath}/MainMember`}
/>
</div>
</div>
{children}
</React.Fragment>)
}